import { PROYECT, api_get, api_post, api_put } from "services/api";

import { FACILITIES_TYPES } from "redux/reducers/buildings/facilities/facilitiesTypes";

import { getStations } from "helpers/companiesNormalized";
import { convertToMap } from "helpers/convertToMap";
import { convertToObjById } from "helpers/convertToObject";
import {
  startRequest,
  stopRequest,
  setSnackbar
} from "redux/actions/search/searchActions";

const {
  SET_FACILITIES,
  NEW_FACILITY,
  SET_NEW_FACILITY,
  EDIT_FACILITY,
  SET_EDITED_FACILITY,
  CLEAR_FACILITIES,
  HANDLE_FACILITIES_INPUTS,
} = FACILITIES_TYPES;

const urlFacilities = `${process.env.REACT_APP_URL}${PROYECT}/buildings/facilities`;
const urlCompanies = `${process.env.REACT_APP_URL}${PROYECT}/companies?id_station`;

export function newFacility() {
  return {
    type: NEW_FACILITY
  };
}
export function clearFacilities() {
  return {
    type: CLEAR_FACILITIES
  };
}

export function editFacility(id) {
  return {
    type: EDIT_FACILITY,
    payload: id
  };
}

export const handleFacilitiesInputsAction = (key, value) => async dispatch => {
  dispatch({ type: HANDLE_FACILITIES_INPUTS, payload: { key, value } });
};

export const fetchFacilities = (idStation = null) => async dispatch => {
  dispatch(startRequest("fetchFacilities"));
  try {
    const [facilities, companies] = await Promise.all([
      api_get(`${urlFacilities}?stations=${idStation}`),
      api_get(urlCompanies)
    ]);

    const newStations = getStations(companies.companies);
    const stationsNormalized = convertToMap(newStations, "id");

    const newFacilities = facilities.map(facility => ({
      ...facility,
      station: stationsNormalized[facility.idStation]?.label ?? ""
    }));

    const facilitiesMap = convertToObjById(newFacilities);
    dispatch({
      type: SET_FACILITIES,
      payload: {
        facilities: newFacilities,
        facilitiesMap,
        stations: newStations,
        stationsMap: stationsNormalized
      }
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchFacilities"));
};

export const fetchNewFacility = body => async dispatch => {
  dispatch(startRequest("fetchNewFacility"));
  try {
    const response = await api_post(urlFacilities, body);

    dispatch({
      type: SET_NEW_FACILITY,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchNewFacility"));
};

export const fetchEditFacility = (body, id) => async dispatch => {
  dispatch(startRequest("fetchEditFacility"));
  try {
    const response = await api_put(`${urlFacilities}/${id}`, body);

    dispatch({
      type: SET_EDITED_FACILITY,
      payload: response
    });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequest("fetchEditFacility"));
};
